@if (!loading) {
  <div class="details-page-header-wrapper">
    <div class="page-header">
      <div class="details-page-back-title">
        <a [routerLink]="[pageReturnURL]" class="details-page-back-btn">
          <rkt-icon name="arrow-left" class="details-page-back-btn-icon"></rkt-icon>
        </a>
        <h1 class="details-page-title">Fund on Hold Details</h1>
      </div>
      <app-breadcrumbs [itemList]="breadcrumbList"></app-breadcrumbs>
    </div>
  </div>
} @else {
  <app-details-page-header-placeholder [pageReturnURL]="pageReturnURL" [withStatus]="false"></app-details-page-header-placeholder>
}

<div class="entity-details-container">
  <div class="details-section">
    <div class="details-row details-row-with-offset">
      <app-details-item
        class="foh-details-id"
        [showPlaceholder]="loading"
        label="Hold ID"
        [title]="$safeNavigationMigration(fundOnHold?.id)"
        [value]="fundOnHold?.id || '' | rktShortId"
      ></app-details-item>

      <app-details-item
        class="foh-details-fa-id"
        [showPlaceholder]="loading"
        label="Financial Account ID"
        [value]="fundOnHold?.financialAccountId ? ' ' : undefined"
      >
        @if (fundOnHold?.financialAccountId) {
          @if (financialAccountUrl) {
            <div class="details-item-link-container">
              <a class="page-link" [routerLink]="financialAccountUrl">
                <rkt-icon name="link"></rkt-icon>
                {{ fundOnHold?.financialAccountId || '' | rktShortId }}
              </a>
            </div>
          } @else {
            <span>{{ fundOnHold?.financialAccountId || '' | rktShortId }}</span>
          }
        }
      </app-details-item>

      <app-details-item
        class="foh-details-expiry"
        [showPlaceholder]="loading"
        label="Expiry Date"
        [value]="$safeNavigationMigration(fundOnHold?.expiry) | date: 'MM/dd/yy HH:mm'"
      ></app-details-item>

      <app-details-item
        class="foh-details-amount"
        [showPlaceholder]="loading"
        label="Total Amount"
        [value]="$safeNavigationMigration(fundOnHold?.amount) | amount: 'USD'"
      ></app-details-item>

      <app-details-item
        class="foh-details-status"
        [showPlaceholder]="loading"
        label="Status"
        [contentValue]="true"
        [value]="fundOnHold?.status ? ' ' : undefined"
      >
        @if (fundOnHold?.status) {
          <span class="status-tag" [ngClass]="'status-tag-' + $safeNavigationMigration(fundOnHold?.status?.toLowerCase())">
            {{ $safeNavigationMigration(fundOnHold?.status) | titlecase }}
          </span>
        }
      </app-details-item>

      <app-details-item
        class="foh-details-external-ref"
        [showPlaceholder]="loading"
        label="External Ref ID"
        [value]="$safeNavigationMigration(fundOnHold?.externalReferenceId)"
      ></app-details-item>

      <app-details-item
        class="foh-details-released-txn"
        [showPlaceholder]="loading"
        label="Released Transaction ID"
        [value]="fundOnHold?.releasedTransactionId ? ' ' : undefined"
      >
        @if (fundOnHold?.releasedTransactionId) {
          @if (releasedTransactionUrl) {
            <div class="details-item-link-container">
              <a class="page-link" [routerLink]="releasedTransactionUrl">
                <rkt-icon name="link"></rkt-icon>
                {{ fundOnHold?.releasedTransactionId || '' | rktShortId }}
              </a>
            </div>
          } @else {
            <span>{{ fundOnHold?.releasedTransactionId || '' | rktShortId }}</span>
          }
        }
      </app-details-item>

      <app-details-item
        class="foh-details-memo"
        [showPlaceholder]="loading"
        label="Memo"
        [value]="$safeNavigationMigration(fundOnHold?.memo)"
      ></app-details-item>
    </div>
  </div>

  <div class="details-separator"></div>

  <div class="details-section">
    <div class="details-row details-row-with-offset">
      <app-details-item
        class="foh-details-created-by"
        [showPlaceholder]="loading"
        label="Created By"
        [value]="$safeNavigationMigration(fundOnHold?.createdBy?.id) | teamMemberName | async"
      ></app-details-item>

      <app-details-item
        class="foh-details-created-at"
        [showPlaceholder]="loading"
        label="Created At"
        [value]="$safeNavigationMigration(fundOnHold?.createdAt) | date: 'MM/dd/yy HH:mm'"
      ></app-details-item>
    </div>

    <div class="details-row details-row-with-offset">
      <app-details-item
        class="foh-details-updated-by"
        [showPlaceholder]="loading"
        label="Updated By"
        [value]="$safeNavigationMigration(fundOnHold?.updatedBy?.id) | teamMemberName | async"
      ></app-details-item>

      <app-details-item
        class="foh-details-updated-at"
        [showPlaceholder]="loading"
        label="Updated At"
        [value]="$safeNavigationMigration(fundOnHold?.updatedAt) | date: 'MM/dd/yy HH:mm'"
      ></app-details-item>
    </div>
  </div>
</div>
